import React from 'react';
import { Button } from 'antd';
import { CloseOutlined, LinkOutlined } from '@ant-design/icons';
import { getLinkTarget } from 'utils';

const ItemLinkChip = ({ onPress, onPick, onClear }) => {
	const target = onPress && getLinkTarget(onPress);
	if (!target)
		return (
			<Button
				type="text"
				size="small"
				icon={<LinkOutlined />}
				aria-label="Add link"
				className="ChecklistEditor-ghost"
				onClick={onPick}
			/>
		);
	return (
		<>
			<Button
				size="small"
				shape="round"
				icon={<LinkOutlined />}
				aria-label={`Link: ${target}`}
				title={target}
				className="ChecklistEditor-chip is-set"
				onClick={onPick}
			>
				<span className="ChecklistEditor-chip-label">{target}</span>
			</Button>
			<Button
				type="text"
				size="small"
				icon={<CloseOutlined />}
				aria-label="Remove link"
				className="ChecklistEditor-ghost"
				onClick={onClear}
			/>
		</>
	);
};

export default ItemLinkChip;
